/**
 * Auto-detects whether the app is rendered standalone (direct visit from
 * an ad landing URL) or embedded in an iframe (widget on the website).
 *
 * - Standalone → render the branded Landing shell around the wizard.
 * - Widget → render only the wizard; parent page handles branding.
 *
 * Allow override via ?mode=widget or ?mode=landing for testing.
 */
export type LayoutMode = 'landing' | 'widget';

export function useLayoutMode(): LayoutMode {
  const override = new URLSearchParams(window.location.search).get('mode');
  if (override === 'landing' || override === 'widget') return override;
  return window.parent === window ? 'landing' : 'widget';
}
